import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ProjectContext } from 'context/Context';

const amenities = [
 'Áreas verdes y espacios para recreación al aire libre',
 'Piscina y/o jacuzzi',
 'Gimnasio o centro de fitness',
 'Área de juegos para niños',
 'Servicio de conserjería',
 'Estacionamiento privado y seguro',
 'Servicio de seguridad las 24 horas',
 'Sala de cine',
 'Sala de eventos y/o reuniones',
 'Terraza o espacio de esparcimiento al aire libre con vistas panorámicas',
 'Servicio de limpieza y mantenimiento de la propiedad',
 'Acceso a internet de alta velocidad',
 'Sistema de automatización para controlar la iluminación y temperatura de las habitaciones'
];

const defaultValues = JSON.parse(localStorage.getItem('createProyect')) || {
 name: '',
 logo: null,
 projectStart: null,
 projectEnd: null,
 amenities: [],
 shortDescription: '',
 description: '',
 products: [],
 financings: [],
 blueprints: [],
 images: [],
 requests: [
  {
   id: 'hjy76g7b656vrf5',
   value:
    'Presentar a la administración del proyecto la documentación necesaria para la firma del acta de separación y copia del volante del pago de separación en un plazo máximo de ocho (8) días, pasada esta fecha, la administración del proyecto no tiene ninguna responsabilidad por la reserva del inmueble y esta queda en libertad de venderlo a otra persona.'
  },
  {
   id: 'dsglhsd8453kk44ssd4',
   value:
    'Son ARRAS: En caso de desistimiento o incumplimiento unilateral de cualquiera de las dos (2) partes sobre las condiciones exigidas en este documento, si es el comprador pagara la suma dada antes de firmar la promesa de compra venta y si es el vendedor, devolverá la totalidad de los pagos recibidos con un interés equivalente al DTF.'
  }
 ],
 qualities: [
  {
   id: 'hhj874h43-ddd-656vrf5',
   value:
    'Ubicación estratégica: al estar cerca de la carretera principal, el proyecto podría ser fácilmente accesible para las personas que quieren visitarlo o utilizarlo. Esto podría aumentar su visibilidad y potencialmente su rentabilidad.'
  },
  {
   id: 'dsgl-fdk93-dfkja-3kk44ssd4',
   value:
    'Potencial turístico: debido a la belleza natural y la ubicación estratégica del proyecto, es posible que tenga un gran potencial turístico. Esto podría ser beneficioso tanto para el propietario del proyecto como para la comunidad circundante, ya que podría atraer turistas y aumentar el comercio local.'
  },
  {
   id: 'hhj8743-ddd-656vrf5',
   value:
    'Belleza natural: la presencia de 2 lagos en el proyecto podría ser una gran atracción para las personas que disfrutan de la naturaleza y actividades al aire libre. Además, la belleza natural del proyecto podría ser un gran atractivo para los turistas.'
  },
  {
   id: 'dsgl-fdk-dfkja-3kk4-4ssd4',
   value:
    'Aislamiento y tranquilidad: aunque el proyecto está a 20 minutos del lugar más cercano, esto podría ser una ventaja para aquellos que buscan aislarse del bullicio de la ciudad y disfrutar de la tranquilidad y la paz de la naturaleza.'
  }
 ]
};

const defaultAmenities = JSON.parse(localStorage.getItem('amenities')) || {
 amenities: [],
 options: amenities.map(a => ({ value: a, label: a }))
};

const ProjectProvider = ({ children }) => {
 const [project, setProject] = useState(defaultValues);

 const [select, setSelect] = useState(defaultAmenities);

 /* useEffect(() => {
  const arrayData = JSON.parse(localStorage.getItem('createProyect'));
  localStorage.setItem('createProyect', JSON.stringify({ ...arrayData, ...project }));
 }, [project]);
  */

 useEffect(() => {
  const arrayData = JSON.parse(localStorage.getItem('amenities'));
  localStorage.setItem('amenities', JSON.stringify({ ...arrayData, ...select }));
 }, [select]);

 const [step, setStep] = useState(1);

 const value = { project, setProject, step, setStep, select, setSelect };
 return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
};

ProjectProvider.propTypes = {
 children: PropTypes.node.isRequired
};

export default ProjectProvider;
